import {
	GamedayApiService,
	TeamService
} from "@prestosports/prestostats-core/Services";
import { SportCodes } from "@prestosports/prestostats-core/Common";
import {
	RESET_CURRENT_TEAMS,
	SAVE_TEAM,
	SAVE_TEAM_COMPLETE,
	SET_CURRENT_TEAMS,
	SET_CURRENT_TEAMS_COMPLETE
} from "./constants";
import gameMuiTheme from "../../views/layout/styles/GameMuiTheme";
import GamedayApiClient from "../../services/gameday-api-client";
import { invertColor } from "../../util/object-util";
import Alert from "../../util/alert";
import { GENERIC_ERROR_MSG } from "../../contstants/errors";
import { GENERIC_SAVED_MSG } from "../../contstants/successes";
import { initPlaysData } from "../football-play/actions";

GamedayApiService.setGamedayApiClient(GamedayApiClient);

export const setCurrentTeams = async (
	{ homeTeam, awayTeam },
	seasonId,
	dispatch
) => {
	dispatch({ type: SET_CURRENT_TEAMS });

	const hTeam = await TeamService.getTeamById(homeTeam.teamId);
	const aTeam = await TeamService.getTeamById(awayTeam.teamId);

	dispatch({
		type: SET_CURRENT_TEAMS_COMPLETE,
		payload: {
			homeTeam: {
				...hTeam.toJSON(),
				color: hTeam.color || gameMuiTheme.palette.teams.home,
				contrastColor: invertColor(
					hTeam.color || gameMuiTheme.palette.teams.home,
					true
				)
			},
			awayTeam: {
				...aTeam.toJSON(),
				color: aTeam.color || gameMuiTheme.palette.teams.visitor,
				contrastColor: invertColor(
					aTeam.color || gameMuiTheme.palette.teams.visitor,
					true
				)
			}
		}
	});
};

const sportPostSaveAction = {
	[SportCodes.Football]: initPlaysData,
	[SportCodes.FlagFootball]: initPlaysData
};

export const saveTeam = async (team, game, dispatch) => {
	dispatch({ type: SAVE_TEAM });

	try {
		const savedTeam = await TeamService.saveTeam(team);
		sportPostSaveAction[game.sportCode]?.(game, dispatch);
		Alert.success(GENERIC_SAVED_MSG);
		dispatch({
			type: SAVE_TEAM_COMPLETE,
			payload: {
				savedTeam: {
					...savedTeam.toJSON(),
					contrastColor: invertColor(savedTeam.color, true)
				}
			}
		});
	} catch (e) {
		Alert.error(GENERIC_ERROR_MSG);
		throw Error(e);
	}
};

export const resetCurrentTeams = (dispatch) => {
	dispatch({
		type: RESET_CURRENT_TEAMS,
		payload: {
			homeTeam: null,
			awayTeam: null
		}
	});
};
